import React, { memo, useCallback } from "react";
import CustomOffCanvas from '../CustomOffCanvas.jsx';
import { useDispatch, useSelector } from "react-redux";
import Dropdown from './Dropdown.jsx';
import { dDDefaultLevelOne, dDDefaultLevelOne1 } from './constants.jsx';
import DdDefaultLevelOne from './DdDefaultLevelOne.jsx';
import DdDefaultSummary from './DdDefaultSummary.jsx';
import { get } from "lodash";
import { setSelectedDdMenuValue } from '../../commonSlice.js';
import Spinners from '../Spinner.jsx';
import "./features.common.styles.scss";
import PropTypes from "prop-types";

const DrillDownOffCanvas = (props) => {
  const {
    gridData,
    check,
    customClass,
    subHeading,
    drillDownLoader,
    getLimit,
    getPage,
    getSearchKey,
    getactiveTabKey,
    currentDrilldown,
  } =props;

  const hello=check;
  const summaryRestrict = ['Projects', 'UserManagement'];
   const offcanvasState = useSelector((state) => state.common?.offcanvasState);
  const commonSliceState = useSelector((state) => state.common);
  const selectedData = get(commonSliceState, "offcanvasState.selectedData", []);
  const dispatch = useDispatch();
  const selectedLevelOne = get(
    commonSliceState,
    "drillDownSelectionState.selectedLevelOne",
    []
  );
  const OpenIssueSummaryList = get(
    selectedData[selectedLevelOne],
    "summaryList.openIssue",
    []
  );
  const predictabilityPlannedSummary = get(
    selectedData[selectedLevelOne],
    "summaryList.plannedSummary",
    []
  );
  const onIssueSlect = useCallback((selectedIssue) => {
    props.onIssueSlect && props.onIssueSlect(selectedIssue);
  }, [props.onIssueSlect]);

  const handlePageLimitChange = useCallback((newPageLimit) => {
    getLimit(newPageLimit);
  }, [getLimit]);

  const handlePageNoChange = useCallback((pageNumber) => {
    getPage(pageNumber);
  }, [getPage]);

  const onSearch = useCallback((key) => {
    getSearchKey(key);
  }, [getSearchKey]);

  const handleactiveTabKey = useCallback((activeTabKey) => {
    getactiveTabKey(activeTabKey);
  }, [getactiveTabKey]);

  return (

    <CustomOffCanvas className="custom-off-canvas">

      <div
        className={
          customClass ? customClass : ""
        }
      >
        <h3 className="flowhead p-0-5">
          {offcanvasState?.title}
          {subHeading && <span>{subHeading} </span>}
        </h3>
        {offcanvasState?.dropDownMenuOptions && (
          <div className="flowact-nav p-0-5">
            <div className="frmgroup col-lg-2 dd_picker flowmetricsDD">
              <Dropdown
                options={
                  offcanvasState?.dropDownMenuOptions
                    ? offcanvasState.dropDownMenuOptions
                    : []
                }
                onChange={(selectedValue) => {
                  dispatch(setSelectedDdMenuValue(selectedValue));
                  offcanvasState?.handleDdMenuChange(selectedValue);
                 }}
                
                hideSelectedOptions={false}
                placeholder= "Sprint"
                closeMenuOnSelect={true}
                defaultValue={offcanvasState.selectedValue}
              />
            </div>
          </div>
        )}
     {drillDownLoader=== true ? (
         <Spinners />
                ) :(
        <div>
   
        <div className={`${offcanvasState?.title === "CODE QUALITY ANALYSIS" ? "analysisChart" : ""}`}>
        {selectedData?.customDrillDownCanvas ? (
          selectedData?.customDrillDownCanvas()
        ) : (
          <>
            <div
              className={`flowbox-row ${
                selectedData.drillDownflowWrapClass
                  ? selectedData.drillDownflowWrapClass
                  : "distribute-wrap flowacti-block"
              } row m-0 mt-3`}
            >
              {!offcanvasState?.isDropDownhide
                ? dDDefaultLevelOne.map((level) => (
                    <DdDefaultLevelOne key={level} level={level}  onIssueSlect={onIssueSlect}{...props} />
                  ))
                : selectedData.customDrilldownHeaders &&
                  dDDefaultLevelOne1.map((level) => (
                    <DdDefaultLevelOne key={level} level={level} {...props} />
                  ))}
            </div>
            {offcanvasState?.title === 'TOP ASSIGNEES' && <h5 className="topassigneeTableTittle">{selectedLevelOne ? selectedLevelOne.toUpperCase() : 'SUMMARY'}</h5>}
            {offcanvasState?.title === 'FLOW PREDICTABILITY' && (
              <h5 className="flowPredictTableTitle">
                  {selectedLevelOne ? selectedLevelOne.toUpperCase() : 'USER SUMMARY'}
              </h5>
            )}
            <div className={`flow-descriptions-block flowpredi-des ${offcanvasState?.title === 'TOP ASSIGNEES' ? 'topassigneeTop' : ''}`}>

              <DdDefaultSummary
              gridState={props}
              getLimit={handlePageLimitChange}
              getPage={handlePageNoChange}
              getSearchKey={onSearch}
              tableData={gridData}
              getactiveTabKey={handleactiveTabKey}
              tableData2={hello}
                summaryTitle={
                  selectedData?.DdtopAssigneeCustomSummary
                    ? `${selectedData?.summaryToptitle}:  ${OpenIssueSummaryList.length}`
                    : selectedData?.summaryToptitle
                }
                summaryList={
                  selectedData.DdtopAssigneeCustomSummary
                    ? OpenIssueSummaryList
                    : selectedData.DdFlowPredictCustomSummary
                    ? predictabilityPlannedSummary
                    : !offcanvasState?.isDropDownhide ||
                      selectedData.customDrilldownHeaders
                    ? get(selectedData[selectedLevelOne], "summaryList", [])
                    : get(selectedData, "summaryList", [])
                }
                thirdDrilldown={offcanvasState?.title=="ISSUE METRICS"?true:false}
                unsetStoriesHeight={gridData?true:false}
              />
            </div>
          </>
        )}
        </div>
        {!(
              summaryRestrict.includes(currentDrilldown) ||
              currentDrilldown === "Flow Predictability" || 
              currentDrilldown === "Flow Velocity & Time" || 
              currentDrilldown === "Flow Load (Active Sprint)" || 
              currentDrilldown === "Flow Efficiency" ||
              currentDrilldown === "Flow Distribution") && (
              <div className="flow-descriptions-block flowpredi-des ">
                <DdDefaultSummary
                  summaryTitle={
                    selectedData?.DdtopAssigneeCustomSummary
                      ? `${selectedData?.summaryBottomtitle}:   ${
                          get(
                            selectedData[selectedLevelOne],
                            "summaryList.doneIssue",
                            []
                          ).length
                        }`
                      : selectedData?.summaryBottomtitle
                  }
                  summaryList={
                    selectedData.DdtopAssigneeCustomSummary
                      ? get(
                          selectedData[selectedLevelOne],
                          "summaryList.doneIssue",
                          []
                        )
                      : get(
                          selectedData[selectedLevelOne],
                          "summaryList.unplannedSummary",
                          []
                        )
                  }
                />
              </div>
            )}
            

       </div>
             )}

      </div>
    </CustomOffCanvas>
  );
};

DrillDownOffCanvas.propTypes = {
  gridData: PropTypes.array,
  check: PropTypes.array,
  customClass: PropTypes.string,
  subHeading: PropTypes.string,
  drillDownLoader: PropTypes.bool,
  onIssueSlect: PropTypes.func,
  getLimit: PropTypes.func,
  getPage: PropTypes.func,
  getSearchKey: PropTypes.func,
  getactiveTabKey: PropTypes.func,
  currentDrilldown: PropTypes.string,
};

DrillDownOffCanvas.defaultProps = {
  gridData: [],
  check: [],
  customClass: "",
  subHeading: "",
  drillDownLoader: false,
  currentDrilldown: "",
};

export default memo(DrillDownOffCanvas);


